import ReactDOM from 'react-dom/client';
import { ReactNode } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const IMG_BOX_HEIGHT = 690;
const IMG_BOX_WIDTH = 868;

const MAX_HEIGHT = 839;

export async function createPdf(
    Com: ReactNode,
    fileName = '中医药广告',
    isFrom = true
): Promise<FormData | File> {
    const $div = document.createElement('div');
    $div.style.width = '1000px';
    $div.style.position = 'absolute';
    $div.style.top = '0px';
    $div.style.left = '0px';
    $div.style.zIndex = '-10';
    const root = ReactDOM.createRoot($div as HTMLElement);
    root.render(Com);
    document.body.appendChild($div);

    return new Promise((resolve, reject) => {
        const time = setTimeout(async () => {
            const file = await handleExportPdf($div, fileName);
            // const file: any = await outputPDF({
            //     element: $div,
            //     contentWidth: 550,
            //     filename: fileName
            // } as any);
            $div.remove();
            clearTimeout(time);
            const formData = new FormData();
            formData.append('files', file);
            resolve(isFrom ? formData : file);
        });
    });
}

const handleExportPdf = async (element: HTMLDivElement, fileName: string) => {
    // 下载尺寸 a4 纸 比例
    const pdf = new jsPDF('p', 'pt', 'a4', true);

    const { imgDataUrl, height, width } = await createCanvas(element, pdf);
    // 样件表导出特殊处理
    const $ImgBox = document.getElementById('yj-img-box');
    if (height > MAX_HEIGHT && $ImgBox) {
        await createPagesPdf($ImgBox, element, pdf);
    } else {
        // pdf.addImage(pageData, 'JPEG', 左，上，宽度，高度)设置
        imgDataUrl && pdf.addImage(imgDataUrl, 'png', 0, 0, width, height);
    }
    // 导出下载
    // await pdf.save(fileName, { returnPromise: true });
    // 返回二进制文件
    const { getBlob, buildDocument } = (pdf as any).__private__;
    let blob = getBlob(buildDocument());
    let file = new File([blob], `${fileName}.pdf`, { type: blob.type });
    return file;
};

// pdf分页逻辑
async function createPagesPdf(el: HTMLElement, element: HTMLElement, pdf: jsPDF) {
    const Boxs = el.querySelectorAll('.img_item');
    const Footer = element.querySelector('#footer') as any;
    const nodes: Record<string, any>[] = [];
    let page = 1;
    Boxs.forEach(($item: any, index) => {
        const { offsetWidth = 0, offsetHeight = 0 } = $item;
        if (index > 0) {
            const preNode = nodes.filter((item) => item.page === page);
            const wTotal = preNode.reduce((total, item) => total + item.width, 0);
            const hTotal = preNode.reduce((total, item) => total + item.height, 0);
            // 宽度相加 < IMG_BOX_WIDTH || 高度相加 < IMG_BOX_HEIGHT
            if (offsetWidth + wTotal > IMG_BOX_WIDTH && offsetHeight + hTotal > IMG_BOX_HEIGHT)
                page += 1;
        }
        nodes.push({
            width: offsetWidth,
            height: offsetHeight,
            el: $item,
            page
        });
    });
    for (let i = 0; i < page; ++i) {
        const $boxs = nodes.filter(({ page }) => page === i + 1);
        el.innerHTML = '';
        $boxs.forEach((item) => el.appendChild(item.el));
        // 设置页码
        if (!!Footer) (Footer as any).innerHTML = `${i + 1}/${page}`;
        const { imgDataUrl, height, width } = await createCanvas(element, pdf);
        if (imgDataUrl) pdf.addImage(imgDataUrl, 'png', 0, 0, width, height);
        // 另起一页
        if (i < page - 1) pdf.addPage();
    }
}

// 创建canvas
async function createCanvas(element: HTMLElement, pdf: jsPDF) {
    // 根据dpi放大，防止图片模糊
    const scale = window.devicePixelRatio > 1 ? window.devicePixelRatio : 2;
    let width = element?.offsetWidth || 0;
    let height = element?.offsetHeight || 0;
    const canvas = document.createElement('canvas');
    canvas.width = width * scale;
    canvas.height = height * scale;
    // 缩放为 a4 大小  pdfpdf.internal.pageSize 获取当前pdf设定的宽高
    height = (height * pdf.internal.pageSize.getWidth()) / width;
    width = pdf.internal.pageSize.getWidth();

    const pdfCanvas = element
        ? await html2canvas(element, {
              useCORS: true,
              canvas,
              scale,
              width,
              height,
              x: 0,
              y: 0
          })
        : null;

    const imgDataUrl = pdfCanvas ? pdfCanvas.toDataURL() : null;

    return { imgDataUrl, height, width };
}
